// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manage-menu .header {\n    display: flex;\n    border-bottom: 1px solid #888;\n    margin-bottom: 5px;\n    padding-bottom: 5px;\n    align-items: center;\n}\n.manage-menu .header div {\n    margin-right: 10px;\n}\n.manage-menu .list-header {\n    font-size: 20px;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
